import { Info } from '@trmediaab/zebra-icons';
import type { CheckoutUser } from '@trmediaab/zebra-types/trhub';

import TextWithAdjacentIcon from '../../components/TextWithAdjacentIcon';

interface InfoTextProps {
  text: string;
  user?: CheckoutUser;
}

const InfoText = ({ text, user }: InfoTextProps) => (
  <TextWithAdjacentIcon
    icon={<Info color="checkout.infoIcon" size="24px" flexShrink="0" mr="2" />}
    text={
      <>
        {user && (
          <>
            Du är inloggad som{' '}
            {user.firstName != null
              ? `${user.firstName}${
                  user.lastName ? ` ${user.lastName}` : ''
                } (${user.email})`
              : user.email}
            .{' '}
          </>
        )}
        {text}
      </>
    }
    fontSize={[0, null, 1]}
    lineHeight="base"
    color="text.faded"
  />
);

export default InfoText;
